import Material from "../Materials"

const doorOffsets = 2.5 //centimeters
const doorThickness = 2 //centimeters

export default 
function Door(params) {

  const positions = {
    "a":[ params.dim[1]/2,  params.dim[2]/2,  params.dim[0]/2-params.structuresize/2 ],
    "b":[ params.dim[1]-params.structuresize/2,  params.dim[2]/2,  0 ],  
    "c":[ params.dim[1]/2,  params.dim[2]/2, -params.dim[0]/2+params.structuresize/2]
  }
  const rotations = {
    "a":[ 0,  Math.PI/2,  0 ],  //A position
    "b":[ 0,  0, 0 ],
    "c":[ 0,  -Math.PI/2, 0 ]
  }

  const doorWidth = (["a","c"].includes(params.side)?params.dim[1]:params.dim[0])/2-doorOffsets-params.structuresize

  return (
    <group 
      position={positions[params.side]}
      rotation={rotations[params.side]}
      item={`door-${params.side}`}
    >
      <mesh 
        castShadow
        receiveShadow
        position={[0,-(params.dim[2]-params.doorheight)/2, doorWidth/2+doorOffsets/2-params.structuresize/2]}
      >
        <Material material={params.material} type={params.type} texture={params.texture}/> 
        <boxGeometry args={[doorThickness,params.doorheight-2*params.structuresize, doorWidth-params.structuresize]} />
      </mesh>
      <mesh  
        castShadow
        receiveShadow
        position={[0,-(params.dim[2]-params.doorheight)/2, -doorWidth/2-doorOffsets/2+params.structuresize/2]}
        //position={[0,-(params.dim[2]-params.doorheight)/2-params.structuresize,-doorWidth/2-doorOffsets/2+params.structuresize/2]}
      >
        <Material material={params.material} type={params.type} texture={params.texture}/> 
        <boxGeometry args={[doorThickness,params.doorheight-2*params.structuresize, doorWidth-params.structuresize]} />
      </mesh>
    </group>
  )
}


